module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Aircraft Landing-00e4b7e66762edc24e1655fd33c57a42.png";